import { Line } from '@react-three/drei'
import * as THREE from 'three'
import type { HitVeiculo } from '../../dominio/didatico/inspecaoVeicular'
import { Rotulo3D } from '../componentes/Rotulo3D'

interface Props {
  hit: HitVeiculo | null
  ativo?: boolean
}

/**
 * Componente 3D para depuração visual da inspeção semântica (Etapa 2).
 * Mostra o ponto exato de impacto, a normal de superfície e o identificador
 * de peça e lado deduzidos pelo motor espacial.
 */
export function DebugHitVeicular3D({ hit, ativo = true }: Props) {
  if (!ativo || !hit) return null

  const { pontoMundo, normalMundo, pecaId, lado, veiculoId, pontoLocal } = hit

  const pontaNormal: [number, number, number] | null = normalMundo
    ? [
        pontoMundo[0] + normalMundo[0] * 0.22,
        pontoMundo[1] + normalMundo[1] * 0.22,
        pontoMundo[2] + normalMundo[2] * 0.22,
      ]
    : null

  const textoRotulo = `${pecaId} (${lado}) • [${pontoLocal.map((c) => c.toFixed(2)).join(', ')}]`

  return (
    <group name="debug:hitVeicular">
      {/* Ponto de impacto na superfície */}
      <mesh position={pontoMundo} renderOrder={100}>
        <sphereGeometry args={[0.022, 12, 12]} />
        <meshBasicMaterial color="#38bdf8" depthTest={false} />
      </mesh>

      {/* Vetor normal de superfície (se disponível) */}
      {pontaNormal && (
        <Line
          points={[pontoMundo, pontaNormal]}
          color="#a855f7"
          lineWidth={2.5}
          renderOrder={100}
        />
      )}

      {/* Rótulo descritivo com peça e lado */}
      <Rotulo3D
        posicao={[pontoMundo[0], pontoMundo[1] + 0.1, pontoMundo[2]]}
        texto={textoRotulo}
        variante="achado"
        fator={4}
        sempreVisivel
      />
    </group>
  )
}
